<template lang="pug">
    div        
        sale-detail-modal(v-model="showDetail")
        v-layout(row wrap flat)
            v-flex.mb-2(xs12 sm12 md12 align-self-center)
                v-toolbar(
                    :color="colors.primary"
                    dark
                    flat
                    height="45"
                    )
                    div.d-flex(
                        style="width: 100%; justify-content: space-betwen; align-items: center;"
                        )
                        span.title VENTA
                        v-btn(
                            :color="colors.secondary"
                            small
                            @click="showDetail = true"
                            ) 
                            v-icon(left) list
                            span VER DETALLE

            v-layout.pa-3(row wrap )
                v-flex.d-flex.xs12(
                    style="justify-content: space-between; align-items:center;"
                )
                    span.font-weight-bold Tipo Documento:
                    v-menu(v-if="showDTEButton" open-on-click bottom)
                        v-btn(slot="activator" block :color="colors.primary" dark)
                            span {{dteTypes.find(dte => dte.value==posSaleType).text}}
                        v-list
                            v-list-tile(v-for='(item, index) in dteTypes' :key='index')
                                v-btn(flat block @click='changeDte(item.value)') {{ item.text }}
                    v-btn(v-else
                        slot="activator"
                        :color="colors.primary"
                        depressed
                        dark)
                        span {{dteTypes.find(dte => dte.value==posSaleType).text}}
                // FIXME: Remover cuando sze ponga en producción
                template(v-if="integrationCountersAreEnabled")
                    v-flex.d-flex.align-center(xs12 v-if="posSaleType === 1 && showTicketCounter")
                        div.labelsInfo Número de boleta activo: 
                        v-text-field(
                            tabindex="-1"
                            outline
                            v-model="implementationTicketNumber"
                            )
                    v-flex.d-flex.align-center(xs12 v-if="posSaleType === 2")
                        div.labelsInfo Número de factura activo: 
                        v-text-field(
                            tabindex="-1"
                            outline
                            v-model="implementationInvoiceTicketNumber"
                            )
                // ENDFIXME

                v-layout.px-3(row wrap v-show="posSaleType==1")
                    v-flex(xs12 sm12 md12)
                        v-divider
                    v-flex(xs9 sm9 md9)
                        div.labelsInfo Subtotal:
                    v-flex(xs3 sm3 md3 v-if="payer === 'SE' && paymentMethod === 1")
                        div.values {{total | mixFormatCurrency}}
                    v-flex(xs3 sm3 md3 v-else)
                        div.values {{subTotal | mixFormatCurrency}}
                    //v-flex(xs12 sm12 md12 v-show="payer === 'SE' && paymentMethod === 1")
                        div.staffSale Se ha añadido un ahorro por venta a personal con efectivo
                    //v-flex(xs9 sm9 md9 v-show="payer === 'SE'")
                        div.staffSale AHORRO POR VENTA A PERSONAL:
                    //v-flex(xs3 sm3 md3 v-show="payer === 'SE'")
                        div.staffSale.values {{(total - netTotal) | mixFormatCurrency}}
                    v-flex(xs9 sm9 md9 v-if="discountOrChargePercentage != 0")
                        div.labelsInfo % Descuento global:
                    v-flex(xs3 sm3 md3 v-if="discountOrChargePercentage != 0")
                        div.values {{discountOrChargePercentage}}%
                    v-flex(xs9 sm9 md9 v-if="amountDiscount != 0")
                        div.labelsInfo Monto Descuento global:
                    v-flex(xs3 sm3 md3 v-if="amountDiscount != 0")
                        div.values ${{amountDiscount}}
                v-layout.pa-3(row wrap v-show="posSaleType==2")
                    v-flex(xs12 sm12 md12)
                        v-divider
                    v-flex(xs9 sm9 md9)
                        div.labelsInfo Subtotal:
                    v-flex(xs3 sm3 md3)
                        div.values {{subTotal | mixFormatCurrency}}
                    v-flex(xs9 sm9 md9)
                        div.labelsInfo % Descuento:
                    v-flex(xs3 sm3 md3)
                        div.values {{discountOrChargePercentage}}%
                    v-flex(xs9 sm9 md9)
                        div.labelsInfo Monto Descuento:
                    v-flex(xs3 sm3 md3)
                        div.values ${{amountDiscount}}
                    v-flex(xs9 sm9 md9)
                        div.labelsInfo Iva:
                    v-flex(xs3 sm3 md3)
                        div.values {{iva | mixFormatCurrency }}
        v-divider 
        v-layout.py-1.px-3.change(row wrap v-show="isChangeTicket === true")
            v-flex(xs9 sm9 md9) TOTAL NUEVO DOCUMENTO:  
            v-flex(xs3 sm3 md3) {{subTotal | mixFormatCurrency}}
            v-flex(xs9 sm9 md9) DESCUENTO POR CAMBIO:  
            v-flex(xs3 sm3 md3) {{subTotal - totalSale | mixFormatCurrency}}
        v-layout.py-1.px-3.total(row wrap v-show="posSaleType==1")
            v-flex(xs9 sm9 md9) TOTAL BOLETA:  
            v-flex(xs3 sm3 md3) {{totalSale | mixFormatCurrency}}
        v-layout.py-1.px-3.total(row wrap v-show="posSaleType==2 ")
            v-flex(xs9 sm9 md9) TOTAL FACTURA:  
            v-flex(xs3 sm3 md3) {{totalSale | mixFormatCurrency}}
        v-layout.py-1.px-3.law(row wrap)
            v-flex(xs9 sm9 md9  v-if="showLaw") LEY REDONDEO:  
            v-flex(xs3 sm3 md3 v-if="showLaw") {{roundingLaw | mixFormatCurrency}}
        //v-layout.py-1.px-3.total(row wrap)
            v-flex(xs9 sm9 md9  v-if="showLaw") PAGO CLIENTE:  
            v-flex(xs3 sm3 md3 v-if="showLaw") {{amountPay | mixFormatCurrency}}
        v-layout.py-1.px-3.total(row wrap v-if="!(totalToPay <= 0)")
            v-flex(xs9 sm9 md9)
                span.red--text POR PAGAR:  
            v-flex(xs3 sm3 md3 color='red darken-1')
                span.red--text {{totalToPay + roundingLaw}}
        v-layout.py-1.px-3.total(v-if="roundingLaw")
            v-flex(xs9 sm9 md9) MONTO FINAL:  
            v-flex(xs3 sm3 md3) {{totalSale + roundingLaw | mixFormatCurrency}}
</template>

<script>
import { mapState, mapActions, mapGetters } from 'vuex'
import CurrencyUtils from '@/mixins/CurrencyUtils'
import SaleDetailModal from './SaleDetailModal'
import MultipleTicketTotalServices from '@/services/API/multiplePaymentTicket/multiplePaymentTicket'
export default {
    name: 'sale-information',
    props: {},
    data: function() {
        return {
            dteTypes: [
                { text: 'Boleta', value: 1 },
                { text: 'Factura', value: 2 },
            ],
            dteSelect: null,

            // FIXME: Remove when in production
            lockInplementationTicketInput: true,
            // ENDFIXME

            showDetail: false,
        }
    },
    computed: {
        integrationCountersAreEnabled() {
            return JSON.parse(process.env.VUE_APP_ENABLE_INTEGRATION_COUNTERS)
        },
        ...mapState('CashDeskModule', {
            iva: 'iva',
            total: 'total',
            totalInvoice: 'totalInvoice',
            posSaleType: 'posSaleType',
            discountOrChargePercentage: 'discountOrChargePercentage',
            payer: 'payer',
            netTotal: 'netTotal',
            arrayPayments: 'arrayPayments',
            lastPaymentMethod: 'lastPaymentMethod',
            paymentMethod: 'paymentMethod',
            payment: 'payment',
            multipleSaleTicket: 'multipleSaleTicket',
            currentCustomerId: 'customerId',
            isChangeTicket: 'isChangeTicket',
        }),

        // FIXME: Remove in production
        ...mapState('IntegrationModule', {
            ticketCounter: 'ticketCounter',
            invoiceTicketCounter: 'invoiceTicketCounter',
        }),
        // ENDFIXME

        ...mapGetters('CashDeskModule', {
            totalToPay: 'totalToPay',
            totalSale: 'totalSale',
            subTotal: 'subTotal',
            amountDiscount: 'amountDiscount',
            roundingLaw: 'roundingLaw',
            currentLines: 'currentLines',
            currentIdMultiTicket: 'currentIdMultiTicket',
        }),

        disableDteChange() {
            return (
                this.multipleSaleTicket &&
                this.multipleSaleTicket.length &&
                this.multipleSaleTicket.some(
                    t => t.changed_dte && t.changed_dte.dte_number
                )
            )
        },

        // FIXME: Remove on production
        implementationTicketNumber: {
            get: function() {
                return this.ticketCounter
            },
            set: function(val) {
                this.setTicketCounter(val)
            },
        },
        implementationInvoiceTicketNumber: {
            get: function() {
                return this.invoiceTicketCounter
            },
            set: function(val) {
                this.setInvoiceTicketCounter(val)
            },
        },
        // ENDFIXME

        showLaw: function() {
            // let response = this.arrayPayments.find(element=>element.paymentMethod==1)
            // let long = this.arrayPayments.length
            // return (response && long==1) ? true : false
            return this.lastPaymentMethod === 1 || this.paymentMethod === 1
        },
        showTicketCounter() {
            return (
                ![2, 3].includes(this.lastPaymentMethod) &&
                ![2, 3].includes(this.paymentMethod)
            )
        },
        amountPay: function() {
            return this.totalSale + this.roundingLaw
        },
        showDTEButton: function() {
            if (this.disableDteChange) return false
            if (this.payer === 'SE') return false
            if (this.total < 2000) return false
            if (this.payment || this.arrayPayments.length > 0) return false
            return true
        },
    },
    methods: {
        ...mapActions('CashDeskModule', {
            setSaleType: 'setSaleType',
            resetSaleAfterRemoveTicket: 'resetSaleAfterRemoveTicket',
        }),
        ...mapActions('IntegrationModule', {
            setTicketCounter: 'setTicketCounter',
            setInvoiceTicketCounter: 'setInvoiceTicketCounter',
        }),
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            resetSnackbarState: 'resetSnackbarState',
            initSnackbar: 'initSnackbar',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        async changeDte(idDte) {
            if (idDte === 1) {
                this.setSaleType(idDte)
                let respMulti = await MultipleTicketTotalServices(
                    this.currentIdMultiTicket
                )
                this.resetSaleAfterRemoveTicket(respMulti)
            } else if (
                idDte === 2 &&
                this.currentLines <= 20 &&
                this.checkSameCustomerMultipleTicket()
            ) {
                this.setSaleType(idDte)
                let respMulti = await MultipleTicketTotalServices(
                    this.currentIdMultiTicket
                )
                this.resetSaleAfterRemoveTicket(respMulti)
            } else if (
                idDte === 2 &&
                this.currentLines > 20 &&
                this.checkSameCustomerMultipleTicket()
            ) {
                //alert('no puede cambiarse tipo documento exceden 20 lineas')
                let snackInfo = this.fillSnack(
                    'warning',
                    `Cambio No permitido`,
                    `Lineas actuales: ${this.currentLines} en Factura el máximo permitido son 20 lineas.`
                )
                this.initSnackbar(snackInfo)
            } else if (
                idDte === 2 &&
                this.currentLines <= 20 &&
                this.checkSameCustomerMultipleTicket() == false
            ) {
                //alert('no puede cambiarse tipo documento exceden 20 lineas')
                let snackInfo = this.fillSnack(
                    'warning',
                    `Cambio No permitido(Clientes distintos)`,
                    `Para pagar facturas multiples estas deben ser del mismo cliente`
                )
                this.initSnackbar(snackInfo)
            }
        },
        /*
         */
        checkSameCustomerMultipleTicket() {
            if (this.multipleSaleTicket.length > 0) {
                let myTicket = this.multipleSaleTicket.filter(
                    r => r.sl_customer_id == this.currentCustomerId
                )
                return myTicket.length == this.multipleSaleTicket.length
                    ? true
                    : false
            } else {
                return true
            }
        },
    },
    watch: {},
    components: {
        'sale-detail-modal': SaleDetailModal,
    },
    mixins: [CurrencyUtils],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
.addBorder {
    border: solid black 2px;
}
.total {
    font-size: 25px;
    font-weight: bold;
}
.values {
    font-weight: bold;
    font-size: 18px;
}
.labelsInfo {
    font-weight: bold;
}
.law {
    font-size: 18px;
    font-weight: bold;
    color: red;
}
.staffSale {
    font-weight: bold;
    color: red;
}
.change {
    font-size: 18px;
    color: green;
}
</style>
